<div class="mwoErrorDiv">
    <span class="errorMwo" (click)="openMwoErrorPopup()">
        Error : MWO exists in CRs
        <fa-icon [icon]="iconPacks.FALINK" class="primaryRed"></fa-icon>
    </span>
</div>

<app-content-popup *ngIf="showMwoErrorPopup" [dialogTitle]="popupTitle" [width]="600" [height]="popupHeight"
    (closeContentPopUp)="closeMwoErrorPopup()">
    <ng-container>
        <div class="popup-table-block">
            <div id="nonStyleMwoGrid" class="mt20">
            <kendo-grid class="popup-table-container" [data]="dataList">
                <kendo-grid-column field="mwoNumber" title="MWO"></kendo-grid-column>
                <kendo-grid-column>
                    <ng-template kendoGridHeaderTemplate>
                    </ng-template>
                    <ng-template kendoGridCellTemplate>
                        <span>already include in</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="cridList" title="Change Request No"></kendo-grid-column>
            </kendo-grid>
            </div>
        </div>
    </ng-container>
</app-content-popup>